import "core-js/modules/es.array.concat";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.keys";
import { searchLayoutByName } from 'redux/saga/entities/bound';
import { selectMediaState } from 'redux/modules/device';
import { selectUserLocation } from 'redux/modules/locale';
import { deepExtract } from 'helpers/deep';
import { PATH as SEARCH_PATH } from './Search.route';
import { DEFAULT_KILOMETERS } from './Map/SearchMap.constants';
import { selectActiveLocation } from './SearchBox/SearchBox.reducer';
import { selectCurrentPage, selectMapView, selectIsMapToggleable } from './Search.reducer';
import { DEFAULT_GEOLOCATION, RESULTS_LAYOUT } from './Search.constants';

var selectFieldInDataOfLayout = function selectFieldInDataOfLayout(field, defaultValue, layout) {
  return deepExtract("data.".concat(field), layout && layout[Object.keys(layout)[0]], defaultValue);
};

export var selectTotalHitsInLayout = selectFieldInDataOfLayout.bind(null, 'total_hits', null);
export var selectSchedulesInLayout = selectFieldInDataOfLayout.bind(null, 'schedules', null);
export var selectVenuesInLayout = selectFieldInDataOfLayout.bind(null, 'venue_tab_items', null);
export var selectRadiusUsedInLayout = selectFieldInDataOfLayout.bind(null, 'radius_used', DEFAULT_KILOMETERS);
export var selectMapItemsInLayout = selectFieldInDataOfLayout.bind(null, 'map_items', []);
export var selectCursorInLayout = selectFieldInDataOfLayout.bind(null, 'cursor', '');
export var selectSearchIdInLayout = selectFieldInDataOfLayout.bind(null, 'search_id', null);
export var selectMetadataInLayout = selectFieldInDataOfLayout.bind(null, 'filter_metadata', {});
export var selectFiltersForHashInLayout = selectFieldInDataOfLayout.bind(null, 'filters_for_hash', {});
export var selectResolvedFilterDataInLayout = selectFieldInDataOfLayout.bind(null, 'resolved_filter_data', {});
export var selectErrorInLayout = selectFieldInDataOfLayout.bind(null, 'module_error', null);
export var selectKeywordAutocompleteEntryInLayout = function selectKeywordAutocompleteEntryInLayout(layout) {
  return deepExtract('keyword_autocomplete_entry', selectResolvedFilterDataInLayout(layout), {});
};
export var selectKeywordAutocompleteValueInLayout = function selectKeywordAutocompleteValueInLayout(layout) {
  return selectKeywordAutocompleteEntryInLayout(layout).name || '';
};
export var selectLocationAutocompleteEntryInLayout = function selectLocationAutocompleteEntryInLayout(layout) {
  return deepExtract('location_autocomplete_entry', selectResolvedFilterDataInLayout(layout), {});
};
export var selectLocationAutocompleteValueInLayout = function selectLocationAutocompleteValueInLayout(layout) {
  return selectLocationAutocompleteEntryInLayout(layout).name || '';
};
export var selectLocationAutocompleteTimezoneInLayout = function selectLocationAutocompleteTimezoneInLayout(layout) {
  return selectLocationAutocompleteEntryInLayout(layout).timezone || '';
};
export var selectCalculatedRadiusKmInLayout = function selectCalculatedRadiusKmInLayout(layout) {
  return deepExtract('location_autocomplete_entry.calculated_radius_km', selectResolvedFilterDataInLayout(layout), '');
};

var layoutResultsEntityKey = function layoutResultsEntityKey(state) {
  return "".concat(RESULTS_LAYOUT, "_").concat(selectCurrentPage(state));
};

export var selectResultsLayout = function selectResultsLayout(state) {
  return searchLayoutByName.select(state, layoutResultsEntityKey(state));
};
export var selectDataFromResultsLayout = function selectDataFromResultsLayout(state) {
  return searchLayoutByName.data(state, layoutResultsEntityKey(state));
};
export var selectLoadingFromResultsLayout = function selectLoadingFromResultsLayout(state) {
  return searchLayoutByName.loading(state, layoutResultsEntityKey(state));
};
export var selectLocationAutocompleteFromSearchResults = function selectLocationAutocompleteFromSearchResults(state) {
  return deepExtract('location_autocomplete_entry', selectResolvedFilterDataInLayout(selectDataFromResultsLayout(state)), {});
};
export var selectFiltersFromSearchResults = function selectFiltersFromSearchResults(state) {
  return selectFiltersForHashInLayout(selectDataFromResultsLayout(state));
};
export var selectResultTypeFromSearchResults = function selectResultTypeFromSearchResults(state) {
  return deepExtract('result_type', selectFiltersFromSearchResults(state));
};
export var makeUrlFromLayout = function makeUrlFromLayout(layout) {
  var metadata = selectMetadataInLayout(layout);

  if (metadata.descriptor && metadata.hash) {
    return "".concat(SEARCH_PATH, "/").concat(metadata.location_descriptor, "/").concat(metadata.descriptor, "/").concat(metadata.hash);
  }
};
export var isRootSearchPath = function isRootSearchPath(pathname) {
  return pathname === SEARCH_PATH;
}; // The user's location for search is async-initialized in app.saga.js
// which calls into search.saga.js' (initializeUserLocationForSearch)

export var getUserLocationForSearch = function getUserLocationForSearch(state) {
  return selectActiveLocation(state) || selectUserLocation(state) || DEFAULT_GEOLOCATION;
};
export var selectShouldShowMap = function selectShouldShowMap(state) {
  return selectMediaState(state).lg || selectMapView(state);
}; // Mobile, map-view

export var selectIsMobileMapView = function selectIsMobileMapView(state) {
  return selectIsMapToggleable(state) && selectMapView(state);
};